import React from "react"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const CheckoutContainer = ({ store, children }) => {
  const { paymentInfo } = store
  const texts = TextBundle({ id: "aldoo-store" })
  return (
    <div className="w-full h-full flex flex-col">
      {paymentInfo?.hasTrial && (
        <div className="px-6 pt-6 mb-4">
          <Typography variant="txt_dim">
            {texts?.trial_payment_message ||
              "Your free trial will begin after you add a payment method. You won't be charged until your trial ends."}
          </Typography>
        </div>
      )}
      {/* The Stripe Elements go here */}
      <div className="flex-1 min-h-0">
        {children}
      </div>
    </div>
  )
}

export default CheckoutContainer
